<template>
    <div class="malt-strategy-low-level-banner" data-testid="strategy-low-level-banner">
        <FakeProfileCardsRow />
        <div class="malt-strategy-low-level-banner__overlay">
            <MaltImg src="/malt-logos/malt_strategy_logo.svg" alt="Malt Strategy Logo" height="32" />

            <p class="malt-strategy-low-level-banner__text">
                {{ $t('search.malt.exec.banner.text') }}
            </p>

            <VJoyButton :href="urlToAdvancedSearch" data-testid="strategy-low-level-banner-cta">
                {{ $t('search.malt.exec.banner.cta') }}
            </VJoyButton>

            <LinkButton
                class="malt-strategy-low-level-banner__info"
                data-testid="strategy-low-level-banner-learn-more-cta"
                @click="goToMaltStrategyCompanies"
            >
                {{ $t('search.banner.malt.strategy.high.level.info.text') }}
            </LinkButton>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {navigateTo, useLocalePrefix} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import LinkButton from '~/components/common/LinkButton.vue';
    import FakeProfileCardsRow from '../profile-cards/FakeProfileCardsRow.vue';
    import {useLinksFrom} from '../useLinks';

    const {withLocalePrefix} = useLocalePrefix();
    const {urlToAdvancedSearch} = useLinksFrom('search_banner_strategy_low_level');

    function goToMaltStrategyCompanies() {
        void navigateTo(withLocalePrefix('/c/maltstrategy/companies'), {external: true});
    }
</script>

<style scoped lang="scss">
    .malt-strategy-low-level-banner {
        position: relative;

        &__grid-layout-overrides {
            // additional lines automatically generated should have a 0px height
            grid-auto-rows: 0;
            // hide cell content overflowing so cells with 0px heigh are not visible
            overflow-y: hidden;
            // remove row gap to avoid a bottom margin
            row-gap: 0;
        }

        &__overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: hsla(0, 0%, 98.8%, 0.9);
            backdrop-filter: blur(3px);

            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: var(--joy-core-spacing-8);
            padding: var(--joy-core-spacing-4);
        }

        &__text {
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-secondary-200);
            margin: 0;
        }
    }
</style>
